/**
 * Strings of the visual overhaul's WP6 (people and Home)
 * (docs/design/visual-overhaul.md §11). Merged into the catalogue after
 * every other table, so a key here may override an older one. The copy is
 * ours (§3.1).
 */
import type { Dict } from '../core';

export const peopleEn: Dict = {
  // the profile card's two labelled dates (T19, P22)
  'people.since.app': 'Account created',
  'people.since.server': 'Joined {server}',
  // the DM header (only the actions that exist)
  'people.dm.profile': 'View profile',
  // Friends: empty states with a hint and a next step (I30)
  'people.fr.onlineNone': 'No friends online',
  'people.fr.onlineHint': 'Friends who are online show up here.',
  'people.fr.allNone': 'No friends yet',
  'people.fr.allHint': 'Add someone by their username to start.',
  'people.fr.pendingHint': 'Friend requests you send or get wait here.',
  'people.fr.blockedHint': "People you block can't message you or send you friend requests.",
  'people.fr.searchHint': 'Try a username or part of a name.',
  'people.fr.addCta': 'Add friend',
  // Message Requests
  'people.req.emptyHint': "First messages from people who aren't your friends wait here.",
};
